export default {
  //validation
  emailRequired: 'Enter a valid email',
  invalidEmail: 'Invalid email address',
  invalidPhone:
    'Invalid mobile no. please enter 10 digits no spaces, parenthesis or dashes',
  passwordRequired: 'Password is required',
  passwordQualify: 'Invalid Password',
  confirmPasswordErr: 'Confirm password',
  matchPassword: 'Passwords do not match',
  passwordContainUsername: 'Password cannot contain username',
  passwordContainFirstName: 'Password cannot contain First Name',
  passwordContainLastname: 'Password cannot contain Last Name',
  passwordContainPeriod: 'Password cannot contain a period',
  enterFirstName: 'Enter your first name',
  enterLastName: 'Enter your last name',
  enterUserName: 'Enter your username',
  invalidUserName: 'Cannot contain special characters or spaces',
  enterOldPassword: 'Please enter your old password',
  capsLockIsOn: 'Caps Lock is ON',


  //shared
  requiredField: 'Required field',
  email: 'Email',
  error: 'error',
  password: 'Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  confirmPassword: 'Confirm Password',
  submit: 'Submit',
  cancel: 'Cancel',
  returnLogin: 'Return to Login',
  firstName: 'First name',
  lastName: 'Last name',
  userName: 'Username',
  register: 'Register',
  login: 'Login',
  phone: 'Mobile Phone',
  forgotPassword: 'Forgot password?',
  forgotPassword2: 'Forgot password',
  forgotUsername: 'Forgot username?',

  //Error
  errorMessage: 'Unfortunately an error occurred which interrupted your session.',
  navigateHome: 'Please navigate to the login page to start over',
  nativateHomeCont: 'or wait as we work to resolve the issue.',

  //ForgotPassword
  enterForInstructions:
    'Enter your username to receive an email with instructions on how to reset your password.',
  placeholdEmail: 'example@email.com',
  placeholdPhone: '5551112222',

  //InfoBox
  info1:
    'Email address provided to the City of Seattle is a public record and may be subject to public disclosure under the Public Records Act, ',
  info2: 'RCW Chapter 42.56',
  info3: '. See our ',
  info4: 'Privacy Statement',
  info5: ' to learn how we manage your information.',
  info6:
    'The City of Seattle has changed security settings and a new password is required. If you have not logged in since December 9th, 2019, please click ',

  //Login
  rememberMe: 'Remember Me',
  doNotHaveAccount: "Don't have a profile?",

  //Maintenance
  maintenanceMessageDefault: 'We will be back online as soon as possible.',
  maintenanceMessageStartAndEnd1: 'The site will be offline starting ',
  maintenanceMessageStartAndEnd2: 'and back online starting',
  maintenanceMessageEndOnly: 'The site will be back online starting',
  maintenanceMessageHeader: 'The site is currently undergoing maintenance.',

  //PasswordNew
  setPassword: 'Set a new password',
  oldPassword: 'Current Password',

  //PasswordReset
  resetPassword: 'Reset password',

  //PasswordSent
  beenSent:
    'If this username exists, instructions to reset your password will be sent to the associated email.',

  //Profile
  profile: 'Profile',
  updatePassword: 'Change Password',
  save: 'Save',

  //Registration
  registration: 'Registration',
  passwordPolicy:
    'Password must be 8 to 20 characters and contain at least one lowercase letter, one uppercase letter, one number and one special character, and cannot contain the first, last, or user name of the user. The "." (period) character is not allowed.',
  alreadyRegistered: 'Already registered? ',

  //ForgotUsername
  forgotUsernameInstructions: 'Enter your email to retrieve your username.',

  //Notifications
  forgotPasswordFailedTitle: 'Failed',
  forgotPasswordFailed: 'There was a problem with this request.',

  loginFailedTitle: 'Login Failed',
  acctLockedTitle: 'Profile Locked',
  loginFailed:
    'Invalid username or password. You have {{errCnt}} more attempts before your profile will be locked.',
  loginFailedInactivated: 'To activate your profile, click the link in the activation email that was sent to your email address.',
  acctLocked:
    'Your profile is locked.  An email was sent to you with instructions.',

  passwordNewSuccessTitle: 'password updated',
  passwordNewSuccess: 'Password successfully updated.',
  passwordNewFailedTitle: 'password update failed',
  passwordNewFailed: 'There was a problem updating your password.',

  passwordResetSuccessTitle: 'password reset',
  passwordResetSuccess: 'Please log in with your new password.',
  passwordResetFailedTitle: 'Password reset failed',
  passwordResetFailed: 'This password link has expired. To get another email to reset your password, please ',
  passwordResetFailedLinkText: 'click here',

  profileSuccessTitle: 'Profile updated',
  profileSuccess: 'Profile successfully updated.',
  profileFailedTitle: 'Profile update failed',
  profileFailed: 'Username already in use.',

  registrationSuccessTitle: 'Registration successful',
  registrationSuccess:
    'Thank you for registering your profile. To activate your profile, click on the link in the email that has been sent to {{email}}.',
  registrationFailedTitle: 'Registration failed',
  registrationFailed: 'Unable to register.',

  activationSuccessTitle: 'Profile Activated',
  activationSuccess: 'Your profile was activated successfully.',
  activationFailedTitle: 'Profile Activation Failed',
  activationFailed: 'You have either already used the activation link or it has expired. ',
  activationFailedLinkText: 'Click here to generate a new email with a valid activation link.',

  reactivationTokenHeader: 'Activation Token Expired?',
  reactivationEnterForInstructions:
  'Enter your username to receive an email with a new activation token.',
  reactivationEmailSuccessTitle: 'Activation Email Sent.',
  reactivationEmailSuccess: 'Please check your email for a new activation link.',
  reactivationEmailFailedTitle: 'Activation Email Failed To Send.',
  reactivationEmailFailed: 'Unfortunately we are not able to send you a new activation link. Please check the username you provided',


  forgotUsernameSuccessTitle: 'Username retrieved',
  forgotUsernameSuccess: 'You will receive an email with your username.',
  forgotUsernameFailedTitle: 'Username retrieval failed',
  forgotUsernameFailed: 'There was a problem retrieving your username.  You can create a new username by ',
  forgotUsernameFailedLinkText: 'registering ',
  forgotUsernameFailedLinkTextSuffix: 'for a profile.',

  kubraTitle: 'Reset Your Password',
  kubraMessage:
    'We made some changes to your online experience. To log in for the first time you’ll need to reset your password. An email has been sent with instructions for resetting your password.',

  appMenu: 'Your Apps',
}
